(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-cafes-thes-main"] && !Shopify.designMode) return;
  try {
    (function () {
    function refreshHeaderCartCount() {
      if (typeof window.mpRefreshHeaderCartCount === 'function') {
        window.mpRefreshHeaderCartCount();
        return;
      }
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
          document.querySelectorAll('.lande-header__cart').forEach(function (cartLink) {
            var badge = cartLink.querySelector('.lande-header__cart-count');
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'lande-header__cart-count';
                cartLink.appendChild(badge);
              }
              badge.textContent = String(count);
            } else if (badge) {
              badge.remove();
            }
          });
        })
        .catch(function () {});
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.mp-cafes-thes-page__card-form');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () { refreshHeaderCartCount(); })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quote-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.getElementById('LandeGlobalQuoteModal');
    if (!modal) return;

    var formEl = modal.querySelector('#LandeGlobalQuoteForm');
    if (formEl) formEl.setAttribute('novalidate', 'novalidate');

    var lastTrigger = null;

    function resetModalAnimation() {
      if (typeof gsap === 'undefined') return;

      var dialog = modal.querySelector('.lande-devis-modal__dialog');
      var overlay = modal.querySelector('.lande-devis-modal__overlay');
      var fields = modal.querySelectorAll('.lande-devis-modal__field');

      gsap.killTweensOf([overlay, dialog, fields]);
      gsap.set([overlay, dialog, fields], { clearProps: 'all' });
    }

    function animateOpen() {
      if (typeof gsap === 'undefined') return;

      var dialog = modal.querySelector('.lande-devis-modal__dialog');
      var overlay = modal.querySelector('.lande-devis-modal__overlay');
      var fields = modal.querySelectorAll('.lande-devis-modal__field');

      gsap.killTweensOf([overlay, dialog, fields]);
      gsap.set([overlay, dialog], { autoAlpha: 0 });
      gsap.set(dialog, { y: 28, scale: 0.96 });
      gsap.set(fields, { autoAlpha: 0, y: 14 });

      gsap.to(overlay, { autoAlpha: 1, duration: 0.35, ease: 'power2.out' });
      gsap.to(dialog, { autoAlpha: 1, y: 0, scale: 1, duration: 0.55, ease: 'power3.out' });
      gsap.to(fields, {
        autoAlpha: 1,
        y: 0,
        duration: 0.38,
        stagger: 0.04,
        delay: 0.2,
        ease: 'power2.out'
      });
    }

    function formatQuoteMessageBody(form, userMessage) {
      function fieldVal(selector) {
        var el = form.querySelector(selector);
        return el && el.value ? String(el.value).trim() : '—';
      }

      var logoEl = form.querySelector('#LandeQuoteLogo');
      var logoYes = modal.getAttribute('data-label-logo-yes') || 'Oui';
      var logoNo = modal.getAttribute('data-label-logo-no') || 'Non';
      var logoLine = 'Personnalisation logo : ' + (logoEl && logoEl.checked ? logoYes : logoNo);

      return [
        modal.getAttribute('data-quote-body-prefix') || 'DEMANDE DE DEVIS — MP AMENITIES',
        '',
        'INFORMATIONS CLIENT',
        '─────────────────────────────',
        'Nom : ' + fieldVal('[name="contact[name]"]'),
        'Email : ' + fieldVal('[name="contact[email]"]'),
        'Téléphone : ' + fieldVal('[name="contact[phone]"]'),
        'Établissement : ' + fieldVal('#LandeQuoteCompany'),
        'Type établissement : ' + fieldVal('#LandeQuoteProperty'),
        'Catégorie : ' + fieldVal('#LandeQuoteCategory'),
        'Quantité estimée : ' + fieldVal('#LandeQuoteQuantity'),
        logoLine,
        '',
        'MESSAGE',
        '─────────────────────────────',
        userMessage
      ].join('\n');
    }

    function clearQuoteFieldErrors(form) {
      form.querySelectorAll('[data-quote-field-error]').forEach(function (el) {
        el.remove();
      });
      form.querySelectorAll('.lande-devis-modal__field--invalid').forEach(function (el) {
        el.classList.remove('lande-devis-modal__field--invalid');
      });
    }

    function markFieldError(fieldWrap, message) {
      if (!fieldWrap || !message) return;
      fieldWrap.classList.add('lande-devis-modal__field--invalid');
      var err = document.createElement('p');
      err.className = 'lande-devis-modal__field-error';
      err.setAttribute('data-quote-field-error', '');
      err.textContent = message;
      fieldWrap.appendChild(err);
    }

    function validateQuoteForm(form) {
      clearQuoteFieldErrors(form);

      var name = form.querySelector('[name="contact[name]"]');
      var email = form.querySelector('[name="contact[email]"]');
      var property = form.querySelector('#LandeQuoteProperty');
      var category = form.querySelector('#LandeQuoteCategory');
      var message = form.querySelector('[name="contact[body]"]');

      var nameVal = name && name.value ? name.value.trim() : '';
      var emailVal = email && email.value ? email.value.trim() : '';
      var propertyVal = property && property.value ? property.value.trim() : '';
      var categoryVal = category && category.value ? category.value.trim() : '';
      var messageVal = message && message.value ? message.value.trim() : '';

      var firstError = '';
      var valid = true;

      if (!nameVal) {
        markFieldError(name.closest('.lande-devis-modal__field'), modal.getAttribute('data-error-name'));
        valid = false;
        firstError = firstError || modal.getAttribute('data-error-name');
      }

      if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        markFieldError(email.closest('.lande-devis-modal__field'), modal.getAttribute('data-error-email'));
        valid = false;
        firstError = firstError || modal.getAttribute('data-error-email');
      }

      if (!propertyVal) {
        markFieldError(property.closest('.lande-devis-modal__field'), modal.getAttribute('data-error-property'));
        valid = false;
        firstError = firstError || modal.getAttribute('data-error-property');
      }

      if (!categoryVal) {
        markFieldError(category.closest('.lande-devis-modal__field'), modal.getAttribute('data-error-category'));
        valid = false;
        firstError = firstError || modal.getAttribute('data-error-category');
      }

      if (!messageVal) {
        markFieldError(message.closest('.lande-devis-modal__field'), modal.getAttribute('data-error-message-required'));
        valid = false;
        firstError = firstError || modal.getAttribute('data-error-message-required');
      }

      return { valid: valid, message: firstError, userMessage: messageVal };
    }

    function getEmailConfig() {
      var webhookUrl = (modal.getAttribute('data-gmail-webhook-url') || '').trim();
      return {
        enabled: modal.getAttribute('data-html-email-enabled') === 'true',
        webhookUrl: webhookUrl,
        publicKey: modal.getAttribute('data-emailjs-public-key') || '',
        serviceId: modal.getAttribute('data-emailjs-service-id') || '',
        templateId: modal.getAttribute('data-emailjs-template-id') || '',
        recipient: modal.getAttribute('data-emailjs-recipient') || 'm.ismail@mpamenities.com',
        recipient2: modal.getAttribute('data-emailjs-recipient-2') || 'm.benyoussef@mpamenities.com'
      };
    }

    function collectQuoteFormData(form, userMessage) {
      function val(selector) {
        var el = form.querySelector(selector);
        return el && el.value ? String(el.value).trim() : '';
      }

      return {
        title: modal.getAttribute('data-email-title') || 'Demande de devis',
        subtitle: modal.getAttribute('data-email-subtitle') || '',
        subject: modal.getAttribute('data-email-subject') || 'Nouvelle demande de devis',
        labelName: modal.getAttribute('data-label-name') || 'Nom',
        labelEmail: modal.getAttribute('data-label-email') || 'Email',
        labelPhone: modal.getAttribute('data-label-phone') || 'Téléphone',
        labelCompany: modal.getAttribute('data-label-company') || 'Établissement',
        labelProperty: modal.getAttribute('data-label-property') || 'Type',
        labelCategory: modal.getAttribute('data-label-category') || 'Catégorie',
        labelQuantity: modal.getAttribute('data-label-quantity') || 'Quantité',
        labelMessage: modal.getAttribute('data-label-message') || 'Message',
        labelSource: modal.getAttribute('data-label-source') || 'Source',
        labelLogo: modal.getAttribute('data-label-logo') || 'Personnalisation logo',
        source: modal.getAttribute('data-label-source') || '',
        name: val('[name="contact[name]"]'),
        email: val('[name="contact[email]"]'),
        phone: val('[name="contact[phone]"]'),
        company: val('#LandeQuoteCompany'),
        property: val('#LandeQuoteProperty'),
        category: val('#LandeQuoteCategory'),
        quantity: val('#LandeQuoteQuantity'),
        logo: (function () {
          var logoEl = form.querySelector('#LandeQuoteLogo');
          if (logoEl && logoEl.checked) {
            return modal.getAttribute('data-label-logo-yes') || 'Oui';
          }
          return modal.getAttribute('data-label-logo-no') || 'Non';
        })(),
        message: userMessage
      };
    }

    function sendHtmlQuoteEmail(form, userMessage) {
      if (!window.MpQuoteEmail) return Promise.resolve(false);
      var config = getEmailConfig();
      var hasWebhook = !!config.webhookUrl;
      var hasEmailJs = config.enabled && config.publicKey && config.serviceId && config.templateId;
      if (!hasWebhook && !hasEmailJs) return Promise.resolve(false);

      var data = collectQuoteFormData(form, userMessage);
      return window.MpQuoteEmail.send(config, data)
        .then(function () {
          return true;
        })
        .catch(function () {
          return false;
        });
    }

    function shopifyContactFailed(html) {
      if (!html) return true;
      var lower = html.toLowerCase();
      if (lower.indexOf('lande-form-message--error') !== -1) return true;
      if (lower.indexOf('form-message--error') !== -1) return true;
      if (lower.indexOf('class="errors"') !== -1) return true;
      if (lower.indexOf('captcha') !== -1 && lower.indexOf('error') !== -1) return true;
      return false;
    }

    function submitShopifyContact(form) {
      var action = form.getAttribute('action') || '/contact';

      return fetch(action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      }).then(function (res) {
        return res.text().then(function (html) {
          if (res.status >= 500) throw new Error('server_error');
          if (shopifyContactFailed(html)) throw new Error('form_error');
          if (res.status >= 400) throw new Error('http_error');
          return true;
        });
      });
    }

    function showQuoteFeedback(form, type, customMessage) {
      var feedback = form.querySelector('[data-lande-global-quote-feedback]');
      if (!feedback) return;

      feedback.hidden = false;
      if (type === 'success') {
        feedback.textContent = modal.getAttribute('data-success-message') || 'Success';
        feedback.style.color = '#0b7a33';
      } else {
        feedback.textContent = customMessage || modal.getAttribute('data-error-message') || 'Error';
        feedback.style.color = '#a94444';
      }
    }

    function openModal(trigger) {
      lastTrigger = trigger || null;

      if (trigger) {
        var burger = trigger.closest('details.lande-header__burger');
        if (burger) burger.removeAttribute('open');

        var productName = trigger.getAttribute('data-quote-product');
        var categoryValue = trigger.getAttribute('data-quote-category-value');
        var messageField = modal.querySelector('[name="contact[body]"]');
        var categoryField = modal.querySelector('#LandeQuoteCategory');

        if (messageField && productName) {
          messageField.value =
            'Bonjour, je souhaite recevoir un devis pour : ' +
            productName +
            '. Merci de me communiquer vos tarifs.';
        }

        if (categoryField && categoryValue) {
          categoryField.value = categoryValue;
        }
      }

      var form = modal.querySelector('#LandeGlobalQuoteForm');
      if (form) clearQuoteFieldErrors(form);

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      resetModalAnimation();
      animateOpen();

      var firstField = modal.querySelector('input[name="contact[name]"]');
      if (firstField) {
        window.requestAnimationFrame(function () {
          firstField.focus();
        });
      }
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      resetModalAnimation();
      if (lastTrigger) lastTrigger.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-lande-global-quote-open]')) {
        e.preventDefault();
        e.stopPropagation();
        openModal(e.target.closest('[data-lande-global-quote-open]'));
        return;
      }

      if (e.target.closest('[data-lande-global-quote-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (modal.hidden) return;
      closeModal();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('#LandeGlobalQuoteForm');
      if (!form || !modal.contains(form)) return;

      e.preventDefault();

      var feedback = form.querySelector('[data-lande-global-quote-feedback]');
      var submitBtn = form.querySelector('button[type="submit"]');
      var messageField = form.querySelector('[name="contact[body]"]');
      var validation = validateQuoteForm(form);

      if (!validation.valid) {
        showQuoteFeedback(form, 'error', validation.message);
        if (validation.message) {
          var firstInvalid = form.querySelector('.lande-devis-modal__field--invalid input, .lande-devis-modal__field--invalid select, .lande-devis-modal__field--invalid textarea');
          if (firstInvalid) firstInvalid.focus();
        }
        return;
      }

      var userMessage = validation.userMessage;

      if (messageField) {
        messageField.value = userMessage;
      }

      if (feedback) {
        feedback.hidden = true;
        feedback.textContent = '';
      }
      if (submitBtn) submitBtn.disabled = true;

      var config = getEmailConfig();
      var hasWebhook = !!config.webhookUrl;
      var hasEmailJs = config.enabled && config.publicKey && config.serviceId && config.templateId;
      var hasHtmlChannel = hasWebhook || hasEmailJs;

      function finishSuccess() {
        if (submitBtn) submitBtn.disabled = false;
        showQuoteFeedback(form, 'success');
        form.reset();
        window.setTimeout(closeModal, 2000);
      }

      function finishError(customMessage) {
        if (submitBtn) submitBtn.disabled = false;
        if (messageField) messageField.value = userMessage;
        showQuoteFeedback(form, 'error', customMessage || modal.getAttribute('data-error-message'));
      }

      if (hasWebhook) {
        sendHtmlQuoteEmail(form, userMessage)
          .then(function (ok) {
            if (ok) {
              finishSuccess();
            } else {
              finishError(modal.getAttribute('data-error-delivery'));
            }
          })
          .catch(function () {
            finishError(modal.getAttribute('data-error-delivery'));
          });
        return;
      }

      Promise.allSettled([
        hasHtmlChannel ? sendHtmlQuoteEmail(form, userMessage) : Promise.resolve(false),
        submitShopifyContact(form)
      ])
        .then(function (results) {
          var htmlOk = results[0].status === 'fulfilled' && results[0].value === true;
          var shopifyOk = results[1].status === 'fulfilled' && results[1].value === true;

          if (htmlOk || shopifyOk) {
            finishSuccess();
            return;
          }

          finishError(modal.getAttribute('data-error-delivery'));
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
